'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';

import { useWindowSize } from 'usehooks-ts';

import UiUtils from '@utils/ui';

export default function HomeCard(props) {
    const { colour, title, text, link, image, imageWidth, imageHeight, imageAlt } = props;

    let bgClass = "absolute inset-x-0 top-0 bottom-[54px] rounded-2xl z-10";

    switch (colour) {
        case "green":
            bgClass = `${bgClass} bg-light-green02`;
            break;
        default:
            break;
    }

    /* Screen Responsive Code */

    const { width } = useWindowSize();

    const [isMobile, setIsMobile] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);

    const [cardClass, setCardClass] = useState("");
    const [titleClass, setTitleClass] = useState("");
    const [imageClass, setImageClass] = useState("");
    const [imageWrapperClass, setImageWrapperClass] = useState("");
    const [textClass, setTextClass] = useState("");

    useEffect(() => {
        const mobile = UiUtils.isMobile(width);
        const desktop = !mobile;
        const largeDesktop = UiUtils.isLargeDesktop(width);
        const xlargeDesktop = UiUtils.isXLargeDesktop(width);

        let cardCls = "box-border w-full flex flex-col justify-start items-stretch h-full";
        if (xlargeDesktop) {
            cardCls = `${cardCls} min-h-[450px]`;
        } else if (largeDesktop) {
            cardCls = `${cardCls} min-h-[504px]`;
        } else if (desktop) {
            cardCls = `${cardCls} min-h-[564px]`;
        }

        let titleCls =  desktop ? "font-vg-medium text-[32px] leading-110 min-h-[70px]" : "font-vg-medium text-[28px] leading-110";

        let imageCls = "box-border relative aspect-card-image rounded-3xl border-green border-8 object-cover z-20";
        //imageCls = desktop ? `${imageCls} mx-8 mt-[-163px] h-60` : `${imageCls} mx-4`;

        const imageWrapperCls = desktop ? "px-8 mt-[-163px]" : "px-4";

        let textCls = "font-vg-book text-base leading-130";
        if (link) {
            textCls = desktop ? `${textCls} min-h-[114px]` : textCls;
        } else {
            textCls = desktop ? `${textCls} min-h-[154px]` : textCls;
        }

        setIsMobile(mobile);
        setIsDesktop(desktop);

        setCardClass(cardCls);
        setTitleClass(titleCls);
        setImageClass(imageCls);
        setImageWrapperClass(imageWrapperCls);
        setTextClass(textCls);

    }, [width, link, setIsMobile, setIsDesktop, setCardClass, 
        setTitleClass, setImageClass, setTextClass, setImageWrapperClass
    ]);

    return (
        <>
            {(isMobile || isDesktop) && (
                <div className="box-border relative w-full h-full">
                    <div className="flex flex-col items-stretch h-full">
                        <div className={cardClass}>
                            <div className="flex flex-col items-start text-black gap-4 py-8 px-[42px] z-20 h-full">
                                <h3 className={titleClass}>{title}</h3>
                                <p className={textClass}>{text}</p>
                                {link && (
                                    <a href={link} className="font-vg-regular text-base underline">Learn more</a>
                                )}
                            </div>
                        </div>
                        <div className={imageWrapperClass}>
                            <Image 
                                src={image}
                                width={imageWidth}
                                height={imageHeight}
                                className={imageClass}  
                                alt={imageAlt}
                            />
                        </div>
                    </div>
                    <div className={bgClass}></div>
                </div>
            )}
        </>
    );
}